<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Create function"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="Function Key: "  required>
          <el-input v-model="functionPermissionDTOS.functionKey" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Name: "  required>
          <el-input v-model="functionPermissionDTOS.functionName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Decription: " >
          <el-input v-model="functionPermissionDTOS.description" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Icon: " >
          <el-input v-model="functionPermissionDTOS.icon" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Url: "  >
          <el-input v-model="functionPermissionDTOS.url" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Is Menu: " >
          <el-switch
            v-model="functionPermissionDTOS.functionType"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="MENU"
            inactive-value="FUNCTION">
          </el-switch>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="addDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'
  let Base64 = require('js-base64').Base64
  export default {
    components: {

    },
    props:  {
      parentId:{
        type: String,
        required: true,
        default: () => ''
      }
   },
    data(){
      return{
        addDialogVisible: false,
        functionPermissionDTOS:{
          enabled: true,
          appKey: this.appKey,
          parentId: this.parentId,
          functionType: true
        },
        dataLoading: false,
      }
    },
    computed: {
    },
    created(){
      
    },


    methods: {
      showDialog(){
        this.functionPermissionDTOS = {enabled: true, appKey: this.appKey, parentId: this.parentId};
        this.addDialogVisible = true;
      },
      hideDialog(){
        this.functionPermissionDTOS = {enabled: true, appKey: this.appKey, parentId: this.parentId};
        this.addDialogVisible = false;
      },
      save(){
        if(!this.functionPermissionDTOS.functionKey){
          this.$message.warning('Function Key can not be empty ');
          return;
        }
        if(!this.functionPermissionDTOS.functionName){
          this.$message.warning('Function Name can not be empty  ');
          return;
        }

        let url = this.baseAcsUrl + '/acs/function-permission/add-function';
        this.dataLoading = true;
        this.functionPermissionDTOS.parentId = this.parentId === '0' ? null : this.parentId;
        let newObj = {...this.functionPermissionDTOS}
        newObj.functionKey = Base64.encode(this.functionPermissionDTOS.functionKey)
        newObj.functionName = Base64.encode(this.functionPermissionDTOS.functionName)
        if(this.functionPermissionDTOS.description){
          newObj.description = Base64.encode(this.functionPermissionDTOS.description)
        }
        if(this.functionPermissionDTOS.icon){
          newObj.icon = Base64.encode(this.functionPermissionDTOS.icon)
        }
        if(this.functionPermissionDTOS.url){
          newObj.url = Base64.encode(this.functionPermissionDTOS.url)
        }
        this.http.post(url,newObj).then(resp =>{
          this.$message.success('Successful operation ');
          this.addDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/function_permission/dialog/add_function.vue